import React from 'react';

import { Center, Loader, Stack } from '@mantine/core';
import AlreadyPurchasedNotice from 'components/SalesPortal/AlreadyPurchasedNotice';
import SalesPortalPackage from 'components/SalesPortal/SalesPortalPackage';
import { useAuth } from 'context/auth-context';
import useAthleteSalesPortalPackage from 'hooks/salesPortal/useAthleteSalesPortalPackage';
import BackHeader from 'layouts/MobileLayout/components/BackHeader';
import NotFound from 'pages/shared/NotFound';
import { useParams } from 'react-router-dom';

const SalesPortalPackagePage = (): JSX.Element => {
  const { packageId } = useParams<{ packageId: string }>();
  const { session } = useAuth();

  const {
    data: packageData,
    isError: packageError,
    isLoading: packageLoading,
  } = useAthleteSalesPortalPackage(packageId, session?.profile?.profileId);

  if (packageLoading) {
    return (
      <Center sx={{ flexGrow: 1 }} p='lg'>
        <Loader />
      </Center>
    );
  }

  if (packageError || (packageData && packageData.data.athleteSalesPortalStatus !== 'ENABLED')) {
    return <NotFound />;
  }

  if (packageData?.data.alreadyPurchased) {
    return (
      <>
        <BackHeader title={'Explore Packages'} />
        <Stack className='content'>
          <AlreadyPurchasedNotice />
        </Stack>
      </>
    );
  }

  return (
    <>
      <BackHeader title={'Explore Packages'} />
      <Stack className='content'>
        <SalesPortalPackage packageData={packageData?.data} />
      </Stack>
    </>
  );
};

export default SalesPortalPackagePage;
